export function usePanelRouteLoading() {
  const isLoading = useState('panel-route-loading', () => false)
  return { isLoading: readonly(isLoading) }
}
